import { render, staticRenderFns } from "./EditComp.vue?vue&type=template&id=7435cf09"
import script from "./EditComp.vue?vue&type=script&lang=js"
export * from "./EditComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports